import {connect} from "react-redux";
import {
    setErrorModalScreen,
    showLoadingScreen
} from "./modal/modal.actions";
import {setToken, resetUserData, setUserName, setFirstName, setLastName} from "./user/user.actions";

const mapStateToProps = ({ user, modal }) => (
    {
        user: user,
        modal: modal
    }
)

const mapDispatchToProps = dispatch => ({
    // modal
    showLoadingScreen: isShow => dispatch(showLoadingScreen(isShow)),
    setErrorModalScreen: modelData => dispatch(setErrorModalScreen(modelData)),

    // user
    setUserName: username => dispatch(setUserName(username)),
    setFirstName: firstName => dispatch(setFirstName(firstName)),
    setLastName: lastName => dispatch(setLastName(lastName)),
    setToken: token => dispatch(setToken(token)),
    resetUserData: () => dispatch(resetUserData())
})

export const Connector = (component) => {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}